<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">

        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2 > बुकिंग और टिकटिंग </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='55'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12  mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="56">
                    <h4 >बुकिंग और टिकटिंग</h4>
                   

                   
                    <label for="" class="mt-4" >बुकिंग और टिकटिंग सुविधा व्यापारियों के
                        लिए एक सहायक उपकरण है। यह लोगों को सेवाओं, आयोजनों या गतिविधियों जैसी चीज़ों
                        के लिए स्थान आरक्षित करने या टिकट खरीदने की सुविधा देता है। इससे योजना बनाना
                        आसान हो जाता है और यह सुनिश्चित हो जाता है कि आप जो चाहते हैं उसका उपयोग कर
                        सकते हैं या उस पर ध्यान दे सकते हैं। व्यापारी इन सुविधाओं का उपयोग ग्राहकों
                        के लिए अपनी सेवाएं बुक करना या टिकट खरीदना आसान बनाने के लिए करते हैं। यह
                        व्यवसायों को सुचारू रूप से चलाने, ग्राहकों को खुश करने और अधिक पैसा कमाने
                        में मदद करता है। व्यवसाय उन्हें मिलने वाली सभी बुकिंग पर नज़र रखने के लिए
                        पे जी ऐप का भी उपयोग कर सकते हैं, ताकि वे उन्हें अच्छी तरह से प्रबंधित कर
                        सकें।

                    </label>

                    <label for="" class="mt-4" >भारत में हर दूसरा व्यक्ति टिकट बुक
                        करने, अपॉइंटमेंट बुक करने, किसी इवेंट की बुकिंग आदि के लिए कतार में खड़ा है।
                        ग्राहकों और व्यापारियों दोनों के लिए टिकटों का प्रबंधन और बुकिंग करना
                        मुश्किल है। इसलिए, पे जी पर, हमने "बुकिंग और टिकटिंग" नामक एक नया उत्पाद
                        लॉन्च किया, जो पे जी पर निःशुल्क उपलब्ध है।

                    </label>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="57">
                    <h4 >बुकिंग और टिकटिंग क्या है? </h4>
                
                    <label for="" class="mt-4" >व्यापारियों के लिए बुकिंग और टिकटिंग
                        सुविधाएँ उन कार्यात्मकताओं और उपकरणों को संदर्भित करती हैं जो व्यवसायों को
                        उनकी सेवाओं, घटनाओं, गतिविधियों या पेशकशों के लिए आरक्षण, नियुक्तियों और
                        टिकट बिक्री का प्रबंधन करने में सक्षम बनाती हैं। ये सुविधाएँ व्यापारियों को
                        अपने परिचालन को कुशलतापूर्वक व्यवस्थित करने, ग्राहक अनुभव बढ़ाने और राजस्व
                        धाराओं को अनुकूलित करने के लिए सशक्त बनाती हैं। व्यापारी एक मजबूत बुकिंग
                        प्रबंधन प्रणाली तक भी पहुंच सकते हैं, जो उन्हें अपनी बुकिंग को कुशलतापूर्वक
                        ट्रैक करने और संभालने में सक्षम बनाता है।

                    </label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="58">

                    <h4 >बुकिंग और टिकटिंग के लाभ </h4>
                   
                    <label for="" class="mt-3" >
                        यहां इस बात का अवलोकन दिया गया है कि बुकिंग और टिकटिंग सुविधाएं व्यापारियों
                        को कैसे लाभ पहुंचाती हैं:
                    </label>
                
                    <ul class="mt-3" >
                        <li>पे जी पर बुकिंग प्रोफ़ाइल बनाना बहुत आसान है। </li>
                        <li class="mt-3">व्यापारी अलग-अलग "रेडी टू यूज़ टेम्प्लेट" का उपयोग कर सकते
                            हैं। .</li>
                        <li class="mt-3">व्यापारी अपने स्वयं के बुकिंग यूआरएल और क्यूआर कोड उत्पन्न
                            कर सकते हैं और भुगतान प्राप्त करने के लिए उन्हें अपने ग्राहकों के साथ
                            साझा कर सकते हैं। </li>
                        <li class="mt-3">ग्राहक अपने टिकट कहीं से भी और किसी भी उपकरण, उदाहरण के लिए
                            लैपटॉप, मोबाइल फोन आदि के माध्यम से बुक कर सकते हैं </li>
                        <li class="mt-3">व्यापारी आयोजनों से उत्पन्न राजस्व को ट्रैक कर सकते हैं, और
                            अपने ग्राहकों द्वारा की गई बुकिंग का प्रबंधन कर सकते हैं </li>
                        <li class="mt-3">पे जी ऑनलाइन भुगतान को सुचारू रूप से लेने के लिए एक एकीकृत
                            भुगतान गेटवे प्रदान करता है। </li>
                    </ul>
                
                    <label for="" class="mt-3" >
                        पे जी मोबाइल एप्लिकेशन में उपयोगकर्ता द्वारा टिकट बुक करने के लिए व्यक्तिगत
                        पक्ष का उपयोग किया जा सकता है और चेक इन के लिए टिकटों को स्कैन करने के लिए
                        व्यापारी पक्ष का उपयोग किया जा सकता है।
                    </label>
                </div>

            </div>
        </div>
  </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                 
                    <h5 >
                        विषयसूची
                    </h5>
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#55">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   What is Booking and Ticketing? </span>
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#56">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >

                                    बुकिंग और टिकटिंग का परिचय </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#57">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >बुकिंग और टिकटिंग क्या है?
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#58">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    बुकिंग और टिकटिंग के लाभ </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi Booking & Ticketing new.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    बुकिंग और टिकटिंग अवलोकन</span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Hindi Booking & Ticketing new.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
           
                <a [routerLink]="['/easy-collect']">  <button class="btn btn-color" (click)="menues('Easy Collect')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;स्मार्ट कलेक्ट

                </button></a>
            </div>
            <div class="col-md-4    ">
               
                <a [routerLink]="['/create-profile']"><button class="btn btn-color" (click)="menues('Creating Profile')"
                    >प्रोफ़ाइल
                    बनाना
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
    </div>